/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RefreshInputs */

const en_refresh = /** @type {(inputs: RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh`)
};

const fr_refresh = /** @type {(inputs: RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualiser`)
};

const de_refresh = /** @type {(inputs: RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisieren`)
};

const it_refresh = /** @type {(inputs: RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna`)
};

const ru_refresh = /** @type {(inputs: RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить`)
};

const es_refresh = /** @type {(inputs: RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refrescar`)
};

const zh_cn2_refresh = /** @type {(inputs: RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刷新`)
};

const ja_refresh = /** @type {(inputs: RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リフレッシュ`)
};

const hi_refresh = /** @type {(inputs: RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ताज़ा करना`)
};

const pt_pt2_refresh = /** @type {(inputs: RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar`)
};

/**
* | output |
* | --- |
* | "Refresh" |
*
* @param {RefreshInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const refresh = /** @type {((inputs?: RefreshInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RefreshInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_refresh(inputs)
	if (locale === "de") return de_refresh(inputs)
	if (locale === "it") return it_refresh(inputs)
	if (locale === "ru") return ru_refresh(inputs)
	if (locale === "es") return es_refresh(inputs)
	if (locale === "zh-CN") return zh_cn2_refresh(inputs)
	if (locale === "ja") return ja_refresh(inputs)
	if (locale === "hi") return hi_refresh(inputs)
	if (locale === "pt-PT") return pt_pt2_refresh(inputs)
	return en_refresh(inputs)
});